import { render, staticRenderFns } from "./MemberNews.vue?vue&type=template&id=5b1b4c0f&scoped=true&"
import script from "./MemberNews.vue?vue&type=script&lang=js&"
export * from "./MemberNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b4c0f",
  null
  
)

export default component.exports